import React, { useState } from 'react';

function HelpButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Help Button */}
      <button id="helpToggle" className="help-btn" onClick={() => setIsOpen(!isOpen)}>
        <iconify-icon icon="mdi:help-circle-outline"></iconify-icon> Help
      </button>

      {/* Help Popup Form */}
      {isOpen && (
        <div id="helpForm" className="help-form shadow" style={{ display: 'block' }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Need Assistance?</h6>
            <button type="button" className="btn-close" onClick={() => setIsOpen(false)}></button>
          </div>

          <form action="https://api.web3forms.com/submit" method="POST">
            <input type="hidden" name="access_key" value="18c9761a-1b94-49be-9259-43d37e9c6067" />
            <input type="hidden" name="redirect" value="https://web3forms.com/success" />

            <div className="mb-2">
              <input type="text" name="name" className="form-control" placeholder="Your Name (optional)" />
            </div>
            <div className="mb-2">
              <input type="email" name="email" className="form-control" placeholder="Email Address" required />
            </div>
            <div className="mb-2">
              <textarea name="message" className="form-control" rows="3" placeholder="How can we help you?" required></textarea>
            </div>
            <button type="submit" className="btn btn-primary w-100" style={{ backgroundColor: '#00aaff' }}>Send</button>
          </form>
        </div>
      )}
    </>
  );
}

export default HelpButton;
